// Registered function — host pages expose this so the shared
// configure form can trigger a catalogue refresh after save / delete.
//
// Default implementation: re-fetch `loadIntegrationCatalogue(orgId)` and
// write the result onto `root._integrationHub`. Pages that need custom
// reload logic can override by redefining the function in their own
// functions/ directory.

import { loadIntegrationCatalogue } from './integrations/index.js'

export const reloadIntegrationHub = async function () {
  const root = this?.state?.root || this
  if (!root) return
  const orgId = root?.jwtClaims?.workspace_org_id
  if (!orgId) return
  try {
    const data = await loadIntegrationCatalogue(orgId)
    root.update({ _integrationHub: data })
  } catch {
    // Silent fail — existing state keeps rendering.
  }
}
